import type { AnalyticsAPI } from 'src/replicant/config/actions/createActions';
import { ChatbotMessagePayload } from '../chatbot/messageTemplates';
import { getIcebreakerStats } from '../stats/stats.analytics';
import { MutableState } from '../State';
import {
  incrementDayStat,
  incrementPersistentStat,
} from '../stats/stats.modifiers';
import { sendAnalyticsEvents } from '../analytics';

const ICEBREAKER_MESSAGE_SUCCESS_SEND_ENABLED = false;

/**
 * IcebreakerMessageSuccess
 *
 * Trigger: Triggers when we send a special greetings messages with flex and quick reply, at the same time as the ChatbotMessageSuccess event
 *
 * @param $channel - The channel where the event is triggered
 * @param feature - The feature of the message
 * @param $subFeature - The subFeature of the message
 * @param daySequence - The count of messages with prompts sent in the day
 * @param absoluteSequence - The count of messages with prompts sent ever
 * @param dayFeatureSequence - The count of messages of the same Feature sent in the day
 * @param absoluteFeatureSequence - The count of messages of the same Feature sent ever
 */
export function trackIcebreakerMessageSuccess(
  state: MutableState,
  feature: 'greeting' | 'greeting_bot_invite',
  payload: ChatbotMessagePayload,
  now: number,
  api: AnalyticsAPI,
) {
  // Increment the icebreaker event stats
  incrementDayStat(state, 'icebreakerDaySequence', now);
  incrementPersistentStat(state, 'icebreakerAbsoluteSequence');

  // Increment the feature sequence stats
  if (feature === 'greeting') {
    incrementDayStat(state, 'icebreakerDayGreetingSequence', now);
    incrementPersistentStat(state, 'icebreakerAbsoluteGreetingSequence');
  }

  // Increment for bot invite
  if (feature === 'greeting_bot_invite') {
    incrementDayStat(state, 'icebreakerDayBotInviteSequence', now);
    incrementPersistentStat(state, 'icebreakerAbsoluteBotInviteSequence');
  }

  // TODO(#11103): Replace this standalone event with ChatbotMessageSuccess.
  if (ICEBREAKER_MESSAGE_SUCCESS_SEND_ENABLED) {
    sendAnalyticsEvents(api, [
      {
        eventType: 'IcebreakerMessageSuccess',
        eventProperties: {
          ...payload,
          ...getIcebreakerStats(state, feature, now),
        },
      },
    ]);
  }
}
